export const frontendURI = '/cat/document_type/';
export const backendURI = `/api${frontendURI}`;
